import React, { Component } from "react";

import { Table } from "react-bootstrap";

import UsersItemsList from "./UsersItemsList";

class UsersList extends Component {
  render() {
    return (
      <Table responsive>
        <thead>
          <tr>
            <th colSpan="6">List of Users</th>
          </tr>
          <tr>
            <th className="users-table-td-name">Username</th>
            <th className="users-table-td-name">Last Name</th>
            <th className="users-table-td-name">First Name</th>
            <th className="users-table-td-check">Is Admin</th>
            <th className="users-table-td-button">Update</th>
            <th className="users-table-td-button">Delete</th>
          </tr>
        </thead>
        <UsersItemsList
          users={this.props.users}
          onEdit={this.props.onEdit}
          onDelete={this.props.onDelete}/>
      </Table>
    );
  }
}

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/users/UsersList.js